import { Capacitor } from '@capacitor/core';
import { store } from '../store/store';
import { setOrderIdToOpen } from '../store/slices/orderModalSlice';

const CHANNEL_ID = 'restroai_orders';
/** Same channel ID the backend uses for FCM so heads-up notifications play sound */
export const FCM_CHANNEL_ID = 'restaurant_notifications';

export async function initLocalNotifications() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { LocalNotifications } = await import('@capacitor/local-notifications');
    const perm = await LocalNotifications.checkPermissions();
    if (perm.display === 'prompt' || perm.display === 'denied') {
      await LocalNotifications.requestPermissions();
    }
    // Channel for local/SSE order notifications (heads-up with sound)
    await LocalNotifications.createChannel({
      id: CHANNEL_ID,
      name: 'RestroAI Orders',
      description: 'New order notifications',
      importance: 5,
      visibility: 1,
      sound: 'default',
      vibration: true,
    });
    // Channel for FCM push (must match backend channelId so heads-up plays sound)
    await LocalNotifications.createChannel({
      id: FCM_CHANNEL_ID,
      name: 'RestroAI Alerts',
      description: 'New orders and alerts',
      importance: 5,
      visibility: 1,
      sound: 'default',
      vibration: true,
    });
  } catch (e) {
    console.warn('Local notifications init failed:', e);
  }
}

export function setupNotificationTapListener() {
  if (!Capacitor.isNativePlatform()) return () => {};
  let listenerHandle = null;
  let cancelled = false;
  (async () => {
    try {
      const { LocalNotifications } = await import('@capacitor/local-notifications');
      if (cancelled) return;
      const handle = await LocalNotifications.addListener('localNotificationActionPerformed', (event) => {
        const orderId = event.notification?.extra?.orderId;
        if (orderId) {
          store.dispatch(setOrderIdToOpen(String(orderId)));
        }
      });
      if (cancelled) {
        handle?.remove?.();
        return;
      }
      listenerHandle = handle;
    } catch (e) {
      console.warn('Local notification tap listener failed:', e);
    }
  })();
  return () => {
    cancelled = true;
    if (listenerHandle?.remove) {
      Promise.resolve(listenerHandle.remove()).catch(() => {});
    }
  };
}

export { CHANNEL_ID };
